"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/auth";

const LoginSignupButtons = () => {
  const pathname = usePathname();
  const { user } = useAuth();

  // Determine if we're on a designers/profiles page
  const isDesignersPage =
    pathname.includes("/designers") ||
    pathname.includes("/join") ||
    pathname.includes("/profiles") ||
    pathname.includes("/portfolios");

  return (
    <div className="flex items-center space-x-2">
      <Link href="https://app.world-class.design/auth">
        <Button
          variant="ghost"
          size="sm"
          className="px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-transparent hover:text-gray-800 transition-colors"
        >
          Login
        </Button>
      </Link>
      {isDesignersPage && !user && (
        <Link
          href="/join"
          className="inline-flex h-10 items-center justify-center rounded-full bg-[#2B1B1C] px-5 text-sm font-medium text-white hover:bg-[#3a2327] transition-colors whitespace-nowrap"
        >
          Apply
        </Link>
      )}
    </div>
  );
};

export default LoginSignupButtons;
